import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { v4 as uuid } from 'uuid'
import { HeliosHttpRequests } from '../models/http.model'
import { HttpRecorderService } from '../services/http-recorder/http-recorder.service'

@Injectable({
  providedIn: 'root',
})
export class DevtoolsHttpInterceptor implements HttpInterceptor {
  constructor(private readonly httpRecorder: HttpRecorderService) {}

  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const requestId = uuid()
    const timer = new Date()
    // Before the request
    this.httpRecorder.recordedHttpRequests$.next({
      ...httpRequest,
      requestId,
    } as HeliosHttpRequests)

    return next.handle(httpRequest).pipe(
      tap(event => {
        // After the request
        if (event instanceof HttpResponse) {
          const endTime = new Date()
          const duration = endTime.getTime() - timer.getTime()
          this.httpRecorder.recordedHttpRequests$.next({
            ...httpRequest,
            requestId,
            response: event,
            duration,
            requestedAt: timer,
            completedAt: endTime,
          } as HeliosHttpRequests)
        }
      }),
    )
  }
}
